import { createContext, useContext } from "react";

/**
 * True inside a surface that must not open pop-ups — the quote workspace (the
 * no-pop-up quoting flow). Everywhere else it is false and nothing changes.
 */
export const InlineSurfaceContext = createContext(false);
export const useInlineSurface = () => useContext(InlineSurfaceContext);
